module.exports = __webpack_public_path__ + "img/bg.72492fb3.png";